import { render, staticRenderFns } from "./PaymentSecurityIcons.vue?vue&type=template&id=6b1c7661&scoped=true&"
import script from "./PaymentSecurityIcons.vue?vue&type=script&lang=js&"
export * from "./PaymentSecurityIcons.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSecurityIcons.vue?vue&type=style&index=0&id=6b1c7661&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1c7661",
  null
  
)

export default component.exports